import { render } from "./DashboardNavbar.vue?vue&type=template&id=6a7f2321"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=6a7f2321&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__